














































































































































































































































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { NewsService, News, order, Orders, SetPriceData, OrderService, File } from '@/api'
import formatter from '@/helpers'
import SetPrice from './SetPrice.vue'

@Component({ components: { PulseLoader, SetPrice } })
export default class ControlPanel extends Vue {
  public newsLoaded = false
  public ordersLoaded = false
  news: News | null = null
  orders: Orders | null = null
  collapsedMap: Map<number, boolean> = new Map<number, boolean>()

  formatDate (val: string | undefined): string {
    return formatter.formatDate(val)
  }

  ordersToPay (): Orders {
    const filtered: Orders = []

    if (this.orders === null) {
      return filtered
    }

    this.orders.forEach(val => {
      if (val.external_status === null) {
        return
      }

      if (val.external_status === 'in_pay' || val.external_status === 'payed') {
        filtered.push(val)
      }
    })

    return filtered
  }

  ordersNew (): Orders {
    const filtered: Orders = []

    if (this.orders === null) {
      return filtered
    }

    this.orders.forEach(val => {
      if (val.external_status === null) {
        return
      }

      if (val.external_status === 'new') {
        filtered.push(val)
      }
    })

    return filtered
  }

  ordersInCheck (): Orders {
    const filtered: Orders = []

    if (this.orders === null) {
      return filtered
    }

    this.orders.forEach(val => {
      if (val.external_status === null) {
        return
      }

      if (val.external_status === 'in_check') {
        filtered.push(val)
      }
    })

    return filtered
  }

  ordersInWork (): Orders {
    const filtered: Orders = []

    if (this.orders === null) {
      return filtered
    }

    this.orders.forEach(val => {
      if (val.external_status === null) {
        return
      }

      if (val.external_status === 'in_work') {
        filtered.push(val)
      }
    })

    return filtered
  }

  mounted (): void {
    NewsService.getNews().then(news => {
      this.news = news
    }).finally(() => {
      this.newsLoaded = true
    })

    OrderService.getOrdersToUser().then(resp => {
      this.orders = resp.items
    }).finally(() => {
      this.ordersLoaded = true
    })
  }

  setPrice (changed: order): void {
    if (changed.user_price === undefined) {
      return
    }

    const data: SetPriceData = {
      order_id: changed.id,
      price: changed.user_price
    }

    OrderService.setPrice({ requestBody: data }).then(resp => {
      if (resp.setted) {
        this.collapsedMap.set(changed.id, true)
      }
    })
  }

  collapsed (toCheck: order): boolean {
    const status = this.collapsedMap.get(toCheck.id)

    if (status === undefined) {
      return true
    }

    return status
  }

  public getFileURL (file: File, ord: order): string {
    let name = file.name
    if (!name.startsWith(ord.number)) {
      name = ord.number + ' ' + file.name
    }

    return 'https://prepodam.ru/api/v2/file/' + file.guid + '/' + file.secret + '/' + name
  }
}
